
<template>
  <span class="srm-upload">
    <a-upload size="large"
              name="file"
              :multiple="multiple"
              :action="importUrl"
              :headers="isLogin"
              @change="importChange"
              :fileList="fileList"
              :beforeUpload="beforeUpload">
      <a-button size="large">
        <a-icon type="upload" />{{text}}
      </a-button>
    </a-upload>
  </span>
</template>

<script>
import { getValueByKey } from '@/public/utils/utils';
export default {
  props: {
    multiple: Boolean,
    fileNum: { type: Number, default: 1 },
    list: { type: Array, default: () => [] },
    text: { type: String, default: '选择文件' },
    // key: { type: String, default: 'file' },
    suffixRule: { type: Array, default: () => [] },
    size: { type: Number, default: 10 }, // M
    uploadUrl: { type: String, default: '/file/uploadAttach' },
  },
  data() {
    return {
      isLogin: { token: U.token, authorization: 'authorization-text' },
      importUrl: '', //导入url
      fileList: [],
      allFileList: [],
    };
  },
  mounted() {
    this.fileList = this.list || [];
    this.allFileList = this.fileList;
    this.importUrl = P.ajaxUrl + this.uploadUrl;
  },
  methods: {
    beforeUpload(file) {
      // 文件校验
      const extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

      if (file.size > this.size * 1024 * 1024) {
        this.$message.error(`上传文件不能超过${this.size}M!`);
        return false;
      }

      if (this.suffixRule.length > 0 && !this.suffixRule.includes(extName)) {
        this.$message.error(`请上传，${this.suffixRule.toString()}等格式的文件!`);
        return false;
      }

      // if (this.fileList.length >= this.fileNum) {
      //   this.$message.error(`单次上传限制${this.fileNum}个文件。`);
      // }
      return true;
    },
    importChange(info) {
      //批量导入
      this.fileList = info.fileList;
      if (info.file.status === 'uploading') {
        return;
      }
      if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`);
      }
      // 后端返回错误信息
      if (info.file.status === 'done' && !getValueByKey(info.file, 'response.success')) {
        this.$message.error(`${info.file.name} 上传失败：${getValueByKey(info.file, 'response.resultMessage')}.`);
      }
      // 过滤掉error和done+有后端错误信息的项
      this.allFileList = info.fileList.filter(
        (d) => d.status === 'uploading' || (d.status === 'done' && getValueByKey(d, 'response.success')),
      );
      const startIndex = this.allFileList.length - this.fileNum;
      this.fileList = startIndex < 0 ? this.allFileList : this.allFileList.slice(startIndex);
    },
    getFileList() {
      if (this.fileList.length === 0) return false;
      if (this.fileNum === 1) {
        const file = this.fileList[0];
        const resultMessageStr = getValueByKey(file, 'response.resultMessage');
        const resultMessage = file.resultMessage || (resultMessageStr && JSON.parse(resultMessageStr))[0];
        return resultMessage;
      }
      return this.fileList
        .filter((d) => d.status === 'done')
        .map((d) => {
          const resultMessageStr = getValueByKey(d, 'response.resultMessage');
          const resultMessage = d.resultMessage || (resultMessageStr && JSON.parse(resultMessageStr))[0];
          return resultMessage;
        });
    },
  },
};
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/srm-detailMes/srm-upload-url.vue